import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-scrutiny-popup',
  templateUrl: './scrutiny-popup.component.html',
  styleUrls: ['./scrutiny-popup.component.scss']
})
export class ScrutinyPopupComponent implements OnInit {
  ScrutinyPopForm:FormGroup;
  APIService: any;
  filteredListExam: any;
  examList: any;
  filteredSrtyList: any;
  SrtyList: any;
  submitpayload: any;
  dialogRef1: MatDialogRef<any>;
  constructor(public umsService: UmsService,private spinner:NgxSpinnerService,
    private modalPopupService: ModalpopService, private httpClient: HttpClient,
    public fb: FormBuilder,public dialogRef: MatDialogRef<ScrutinyPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {this.APIService = environment.serviceUrl;  }

  ngOnInit(): void {
    this.ScrutinyPopForm = this.fb.group({
      Srty: new FormControl(''),
      Text: new FormControl(''),
    });
    this.fetchSrty();
  }

  fetchSrty() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SRTY';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.SrtyList = res.data;
        this.filteredSrtyList = this.SrtyList.slice();
      } else{
        this.spinner.hide();
        // let data = {};
        // data['message'] = res.message;
        // data['title'] = 'Information';
        // data['icon'] = 'fas fa-close';
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  close() {
    this.dialogRef.close();
  }
  
  submit(){
    this.submitpayload = this.ScrutinyPopForm.value;
    let arr1 = [];
    if(this.submitpayload.Srty == 'APPR'){
      this.data.ScrutinyLevel = this.data.ScrutinyLevel + 1
    }
    else if(this.submitpayload.Srty == 'DCERR'){
      this.data.ScrutinyLevel = 1;
    }
        arr1.push(
          this.fb.group({
            Status: new FormControl(this.submitpayload.Srty),
            Comment: new FormControl(this.submitpayload.Text),
            ScrutinyLevel: new FormControl(this.data.ScrutinyLevel),
            UserId: new FormControl(this.data.UserId),
            ScrutinyId: new FormControl(this.data.ScrutinyId),
          })
        )
        this.umsService.updateScrutiny(arr1[0].value).subscribe(res => {
          // this.spinner.hide();
          if (res.status){
            let  data = {}
            data['message'] = res.message
            data['title'] = 'Information'
            data['icon'] = 'fas fa-check'
            this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          } else {
            // this.spinner.hide();
            let  data = {}
            data['message'] = res.message
            data['title'] = 'Information'
            data['icon'] = 'fas fa-check'
            this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          }
        }, (ERROR: HttpErrorResponse) => {
          // this.spinner.hide();
          let  data = {}
          data['message'] = ERROR.error.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-box-open'
          this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        });
        
  }
}
